(function () {
	function initCustomProductSliders(root) {
		var containers = (root || document).querySelectorAll('.custom-slider-container');
		containers.forEach(function (container) {
			if (container.dataset.sliderInitialized) {
				return;
			}
			container.dataset.sliderInitialized = 'true';

			var track = container.querySelector('.custom-slider-track');
			var slides = container.querySelectorAll('.product-card-slide');
			var prevBtn = container.querySelector('.slider-btn.prev');
			var nextBtn = container.querySelector('.slider-btn.next');

			if (!track || slides.length === 0 || !prevBtn || !nextBtn) {
				return;
			}

			var index = 0;

			function updateSlider() {
				track.style.transform = 'translateX(-' + index * slides[0].offsetWidth + 'px)';
			}

			nextBtn.addEventListener('click', function () {
				if (index < slides.length - 1) {
					index++;
					updateSlider();
				}
			});

			prevBtn.addEventListener('click', function () {
				if (index > 0) {
					index--;
					updateSlider();
				}
			});

			window.addEventListener('resize', updateSlider);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initCustomProductSliders();
		});
	} else {
		initCustomProductSliders();
	}

	if (window.Shopify && Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (event) {
			initCustomProductSliders(event.target);
		});
	}
})();
